/* MoRetro Studio V28.4 - Full-width collapsible sidebar */
window.MTS = window.MTS || {};

(function(MTS){
  "use strict";

  const KEY = "moretroStudioSidebarHiddenV28";

  function isHidden(){
    try{ return localStorage.getItem(KEY) === "1"; }
    catch(e){ return false; }
  }

  function apply(hidden){
    document.documentElement.classList.toggle("mts-sidebar-hidden", hidden);
    const button = document.getElementById("mtsSidebarToggle");
    if(button){
      button.setAttribute("aria-expanded", hidden ? "false" : "true");
      button.title = hidden ? "Afficher le menu" : "Masquer le menu";
    }
    try{ localStorage.setItem(KEY, hidden ? "1" : "0"); }catch(e){}
    window.dispatchEvent(new Event("resize"));
  }

  function ensureButton(){
    const topbar = document.querySelector(".mts-topbar");
    if(!topbar || document.getElementById("mtsSidebarToggle")) return;

    const button = document.createElement("button");
    button.type = "button";
    button.id = "mtsSidebarToggle";
    button.className = "mts-sidebar-toggle";
    button.innerHTML = "<span></span><span></span><span></span>";
    button.setAttribute("aria-label", "Afficher ou masquer le menu");
    button.addEventListener("click", ()=>apply(!document.documentElement.classList.contains("mts-sidebar-hidden")));
    topbar.prepend(button);
    apply(isHidden());
  }

  const observer = new MutationObserver(ensureButton);
  observer.observe(document.documentElement, {childList:true, subtree:true});

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", ensureButton);
  }else{
    ensureButton();
  }

  MTS.Layout = {apply, isHidden};
})(window.MTS);
